import { get, post, put, del, patch } from "../common/apiClient";

const PATH_FORM_CONFIG = "/form-config";
const PATH_FORM_SUBMISSION = "/form-submission";
// const REACT_APP_API_BASE_URL = "http://localhost:4000/api/v2";
const REACT_APP_API_BASE_URL = "https://api.bmc.io.vn/api/v2";
// Form Config APIs
export const getAllFormConfigs = async () => {
  return await get(PATH_FORM_CONFIG);
};

export const getFormConfigById = async (id) => {
  return await get(`${PATH_FORM_CONFIG}/${id}`);
};

export const createFormConfig = async (formConfig) => {
  return await post(PATH_FORM_CONFIG, formConfig);
};

export const updateFormConfig = async (id, formConfig) => {
  return await put(`${PATH_FORM_CONFIG}/${id}`, formConfig);
};

export const deleteFormConfig = async (id) => {
  return await del(`${PATH_FORM_CONFIG}/${id}`);
};

export const toggleFormConfigStatus = async (id) => {
  return await patch(`${PATH_FORM_CONFIG}/${id}/toggle-status`);
};

// Form Submission APIs
export const getSubmissions = async (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      searchParams.append(key, params[key]);
    }
  });

  const queryString = searchParams.toString();
  return await get(
    `${PATH_FORM_SUBMISSION}${queryString ? `?${queryString}` : ""}`
  );
};

export const getSubmissionById = async (id) => {
  return await get(`${PATH_FORM_SUBMISSION}/${id}`);
};

export const updateSubmissionStatus = async (id, status, notes) => {
  return await patch(`${PATH_FORM_SUBMISSION}/${id}/status`, { status, notes });
};

export const deleteSubmission = async (id) => {
  return await del(`${PATH_FORM_SUBMISSION}/${id}`);
};

export const getSubmissionStats = async (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      searchParams.append(key, params[key]);
    }
  });

  const queryString = searchParams.toString();
  return await get(
    `${PATH_FORM_SUBMISSION}/stats${queryString ? `?${queryString}` : ""}`
  );
};

// Excel Export APIs
export const exportSubmissionsToExcel = async (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      searchParams.append(key, params[key]);
    }
  });

  const queryString = searchParams.toString();

  // Sử dụng fetch thay vì axios để xử lý blob
  const response = await fetch(
    `${
      REACT_APP_API_BASE_URL || "https://api.bmc.io.vn/api/v2"
    }${PATH_FORM_SUBMISSION}/export/excel${
      queryString ? `?${queryString}` : ""
    }`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Failed to export Excel file");
  }

  return response.blob();
};

export const exportFormTemplate = async (formConfigId) => {
  const response = await fetch(
    `${
      REACT_APP_API_BASE_URL || "https://api.bmc.io.vn/api/v2"
    }${PATH_FORM_SUBMISSION}/export/template/${formConfigId}`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Failed to export template");
  }

  return response.blob();
};
